import { Print as PrintIcon } from "@mui/icons-material";
import { CircularProgress, IconButton } from "@mui/material";
import { useRef, useState } from "react";
import ReactToPrint from "react-to-print";

export const Print = ({ componentRef, setPrintMode, sx, onBeforePrint }: any) => {
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    const triggerRef = useRef<any>(null);

    const handlePrint = async () => {
        setPrintMode(true);
        if (onBeforePrint) {
            await onBeforePrint();
        }
        setTimeout(() => {
            triggerRef.current?.click();
            setPrintMode(false);
        }, 1000);
    };

    const onBeforeGetContent = async () => {
        setLoading(true);
        setPrintMode(true); // Indicate print mode is active
        // You can add a small delay here if needed, but usually not required
        // await new Promise(resolve => setTimeout(resolve, 100));
        return Promise.resolve(); // Ensure it returns a Promise
    };

    const onAfterPrint = () => {
        setLoading(false);
        setPrintMode(false); // Reset print mode
    };

    return (
        <>
            <ReactToPrint
                trigger={() => <section hidden ref={triggerRef} />}
                content={() => componentRef.current}
                onBeforeGetContent={onBeforeGetContent}
                onAfterPrint={onAfterPrint}
            />

            <IconButton onClick={handlePrint} sx={sx} size="small">
                {loading ? (
                    <CircularProgress size={20} color="primary" />
                ) : (
                    <PrintIcon fontSize="small" />
                )}
            </IconButton>
        </>
    );
};
